import { Box, Typography, useTheme } from '@mui/material';
import { InfoListItemText, LeftIconBox } from './style';

function AdditionalResources({ resources }) {
    const theme = useTheme();

    const handleClick = (item) => {
        window.open(item.link, '_blank');
    };

    return (
        <Box>
            <Typography component="h4" variant="paraText2" color={'text.secondary'}>
                Additional resources
            </Typography>

            <Box sx={{ listStyle: 'none' ,marginTop:"0.5rem"}}>
                {resources.map((cList, index) => (
                    <Box
                        key={index}
                        sx={{
                            padding: `${theme.typography.generic.xSmall} ${theme.typography.generic.medium}`,
                            background: theme.palette.gray[200],
                            borderRadius: theme.typography.borderRadius.xSmall, // "0.5rem",

                            marginBottom: '0.25rem',
                            '&:last-child': {
                                marginBottom: '0',
                            },
                        }}
                    >
                        <>
                            <LeftIconBox>
                                <InfoListItemText onClick={() => handleClick(cList)} component="p" variant="subtitle2">
                                    {cList.name}
                                </InfoListItemText>
                            </LeftIconBox>
                        </>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}

export default AdditionalResources;
